const TemplatesIcon = () => {
  return (
    <svg width={20} height={21} viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.6 14.2992V16.8192C13.6 17.8273 13.6 18.3314 13.4038 18.7164C13.2312 19.0551 12.9559 19.3305 12.6172 19.503C12.2321 19.6992 11.7281 19.6992 10.72 19.6992H3.88C2.87191 19.6992 2.36786 19.6992 1.98282 19.503C1.64413 19.3305 1.36876 19.0551 1.19619 18.7164C1 18.3314 1 17.8273 1 16.8192V9.97922C1 8.97112 1 8.46708 1.19619 8.08204C1.36876 7.74334 1.64413 7.46798 1.98282 7.29541C2.36786 7.09922 2.87191 7.09922 3.88 7.09922H6.4M9.28 14.2992H16.12C17.1281 14.2992 17.6321 14.2992 18.0172 14.103C18.3559 13.9305 18.6312 13.6551 18.8038 13.3164C19 12.9314 19 12.4273 19 11.4192V4.57922C19 3.57112 19 3.06708 18.8038 2.68204C18.6312 2.34334 18.3559 2.06798 18.0172 1.89541C17.6321 1.69922 17.1281 1.69922 16.12 1.69922H9.28C8.27191 1.69922 7.76786 1.69922 7.38282 1.89541C7.04413 2.06798 6.76876 2.34334 6.59619 2.68204C6.4 3.06708 6.4 3.57112 6.4 4.57922V11.4192C6.4 12.4273 6.4 12.9314 6.59619 13.3164C6.76876 13.6551 7.04413 13.9305 7.38282 14.103C7.76786 14.2992 8.27191 14.2992 9.28 14.2992Z"
        stroke="white"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TemplatesIcon;
